module.exports = __webpack_public_path__ + "img/5_10.7274c911.png";